import { render, staticRenderFns } from "./TenancyBankInfo.vue?vue&type=template&id=f49a618a&scoped=true&"
import script from "./TenancyBankInfo.vue?vue&type=script&lang=js&"
export * from "./TenancyBankInfo.vue?vue&type=script&lang=js&"
import style0 from "./TenancyBankInfo.vue?vue&type=style&index=0&id=f49a618a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f49a618a",
  null
  
)

export default component.exports